export default __webpack_public_path__ + "images/0x4e71a2e537b7f9d9413d3991d37958c0b5e1e503.png";